import styled from 'styled-components';

export const Form = styled.form`
  max-width: 90%;
  margin: 0 auto;
  text-align: left;
`